import { render, staticRenderFns } from "./FabricConfigurationModal.vue?vue&type=template&id=6d12abb2&scoped=true"
import script from "./FabricConfigurationModal.vue?vue&type=script&lang=js"
export * from "./FabricConfigurationModal.vue?vue&type=script&lang=js"
import style0 from "./FabricConfigurationModal.vue?vue&type=style&index=0&id=6d12abb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d12abb2",
  null
  
)

export default component.exports